<template>
<router-view/>
</template>

<script>
export default {
  name: "ConferenceManagementWrapper"
}
</script>

<style scoped>

</style>